import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import './styles/app.css'

const app = createApp(
  App,
  { GIT_REVISION: process.env.GIT_REVISION }
)

app.use(router)
app.mount('#app')

export default app
